<script>
import FeatureWrapper from '~/components/feature-page/FeatureWrapper.vue';

export default FeatureWrapper;
</script>
